import "tailwindcss/dist/base.css";
import "styles/globalStyles.css";
import React from "react";

import ServiceLandingPage from "./ServiceLandingPage.js";

export default ServiceLandingPage;
